import React from "react";

export type LogoIconProps = React.SVGProps<SVGSVGElement>;

const LogoIcon: React.FC<LogoIconProps> = (props) => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 300 136.8"
      {...props}
    >
      <defs>
        <style>{`
          .st0 { fill: #374240; }
          .st1 { fill: #2b3231; }
          .st2 { fill: none; }
          .st3 { clip-path: url(#clippath-1); }
          .st4 { fill: #0d84c7; }
          .st5 { fill: #2172b9; }
          .st6 { fill: #2a3231; }
          .st7 { clip-path: url(#clippath); }
        `}</style>
        <clipPath id="clippath">
          <rect className="st2" x="0" y="0" width="300" height="87" />
        </clipPath>
        <clipPath id="clippath-1">
          <rect className="st2" x="0" y="0" width="300" height="87" />
        </clipPath>
      </defs>
      <g id="RGB_SSF_logo_1">
        <g className="st7">
          <g className="st3">
            <path
              className="st5"
              d="M12.7,26.9c1-.3,2.1-.5,3.1-.5h16.7v-9.9H14.6c-1.6,0-3.2.2-4.9.6-1.8.4-3.4,1.1-4.8,2.1-1.4,1-2.6,2.2-3.6,3.8C.5,24.6,0,26.5,0,28.8s.6,5.2,1.9,6.9c1.3,1.7,2.9,3.1,4.8,4.2,2.2,1.2,4.4,2,6.7,2.5,2.3.5,4.6,1,6.8,1.7.4.1.8.3,1.1.4.4.2.5.9.5,2-.1,1.4-.8,2.3-2.1,2.7-1.2.4-2.4.5-3.7.5H0v10h18.7c2.6,0,4.8-.4,6.6-1.2,1.8-.8,3.2-1.8,4.2-3.1,1.1-1.3,1.8-2.8,2.3-4.5.5-1.7.7-3.5.7-5.4s-.3-3.8-1-5.2c-.6-1.4-1.5-2.5-2.6-3.4-1.1-.9-2.2-1.6-3.6-2.1-1.3-.5-2.7-.9-4-1.3-1.4-.3-2.7-.6-3.9-.8-1.3-.2-2.4-.5-3.4-.9-1-.3-1.8-.7-2.3-1.1-.5-.5-.8-1.1-.8-1.9s.6-1.5,1.7-1.9"
            />
            <path
              className="st5"
              d="M63.5,47.7c-1.2,1.3-3.4,2-6.5,2h-2.3c-1.2,0-2.2,0-3-.2s-1.3-.4-1.7-.6c-.4-.3-.6-.6-.8-1.1-.1-.4-.3-.9-.3-1.5,0-.5.1-1,.3-1.4.1-.4.4-.8.7-1.1.4-.3.9-.6,1.6-.8.7-.2,1.8-.4,3.1-.5l10.8-1.1c0,2.8-.7,4.9-1.9,6.2M73.1,20.6c-2.2-2.6-5.9-3.9-11-4h0s-24.2,0-24.2,0v10h22.1c1.2,0,2.1.1,2.8.3.8.2,1.4.5,1.8.8.4.4.7.8.7,1.2,0,.5.1,1,.1,1.5v1.4l-13,1.1c-5,.5-8.7,1.9-11,4.4-2.3,2.4-3.5,5.5-3.5,9.1s.4,4.1,1.1,5.7c.7,1.6,1.8,3,3.1,4.1,1.3,1.1,2.9,2,4.7,2.5,1.8.6,3.7.8,5.8.8h5c1.2,0,2.8-.2,4.7-.7,1.9-.5,3.6-1.3,5.2-2.3l1.2,2.4h7.8v-26.6c0-5.2-1.1-9.1-3.3-11.8"
            />
            <path
              className="st5"
              d="M99.5,12.9c0-.7.3-1.3.7-1.7.4-.4.9-.7,1.7-.9.7-.2,1.7-.2,2.9-.3h6.1V0h-9.1c-4.7.2-8.2,1.5-10.4,3.9-2.4,2.6-3.5,6.5-3.2,11.7v1.4c0,0-8.3,0-8.3,0v9.3h8.4v32.6h11.2V26.3h11.4v-9.3h-11.4v-1.5c0-1.1,0-1.9.1-2.6"
            />
            <path
              className="st5"
              d="M126.5,32.7c0-1.2,0-2.2,0-3,0-.8.3-1.4.6-1.9.3-.5.9-.8,1.7-1,.8-.2,1.9-.3,3.4-.3h4.8c1.3,0,2.3,0,3.1.2.8.1,1.4.4,1.8.7.4.3.6.6.7,1.1.1.4.2.9.2,1.4s0,.9-.1,1.2c0,.4-.3.7-.7.9-.4.3-1,.5-1.8.7-.8.2-1.9.4-3.3.5l-10.4,1.1v-1.7ZM129,49.4c-.8-.2-1.4-.5-1.8-.9-.4-.4-.6-1-.7-1.8,0-.7-.1-1.7-.1-2.8,1.1,0,2.8-.1,4.9-.3,2.2-.1,4.8-.3,8-.5,2-.1,4-.5,5.7-1.1,1.8-.6,3.3-1.5,4.7-2.6,1.3-1.1,2.3-2.5,3.1-4.1.7-1.6,1.1-3.4,1.1-5.5s-.4-4.2-1.1-5.9c-.7-1.7-1.8-3.1-3.1-4.1-1.3-1.1-2.9-1.9-4.7-2.5-1.8-.6-3.7-.8-5.9-.8h-9.2c-5.4,0-9.2,1.3-11.4,4-2.2,2.7-3.3,6.6-3.3,11.8v11.5c0,5.1,1.1,9,3.4,11.7,2.2,2.6,6,4,11.2,4h0s24.1,0,24.1,0v-10h-22.3c-1.1,0-1.9-.1-2.6-.2"
            />
            <rect className="st6" x="199.2" y="16.5" width="11.1" height="42" />
            <path
              className="st6"
              d="M174,26.9c1-.3,2.1-.5,3.1-.5h16.7v-9.9h-17.9c-1.6,0-3.2.2-4.9.6-1.8.4-3.4,1.1-4.8,2.1-1.4,1-2.6,2.2-3.6,3.8-.9,1.6-1.4,3.5-1.4,5.8s.6,5.2,1.9,6.9c1.3,1.7,2.9,3.1,4.8,4.2,2.2,1.2,4.4,2,6.7,2.5,2.3.5,4.6,1,6.8,1.7.4.1.8.3,1.1.4.4.2.5.8.5,2-.1,1.4-.8,2.3-2.1,2.7-1.2.4-2.4.5-3.7.5h-16.2v10h18.7c2.6,0,4.8-.4,6.6-1.2,1.8-.8,3.2-1.8,4.2-3.1,1.1-1.3,1.8-2.8,2.3-4.5.5-1.7.7-3.5.7-5.4s-.3-3.8-1-5.2c-.6-1.4-1.5-2.5-2.6-3.4-1.1-.9-2.2-1.6-3.6-2.1-1.3-.5-2.7-.9-4-1.3-1.4-.3-2.7-.6-3.9-.8-1.3-.2-2.4-.5-3.4-.9-1-.3-1.8-.7-2.3-1.1-.5-.5-.8-1.1-.8-1.9s.6-1.5,1.7-1.8"
            />
            <path
              className="st6"
              d="M262.6,32.7c0-1.2,0-2.2,0-3,0-.8.3-1.4.6-1.9.3-.5.9-.8,1.7-1,.8-.2,1.9-.3,3.4-.3h4.8c1.3,0,2.3,0,3.1.2.8.1,1.4.4,1.7.7.4.3.6.6.7,1.1.1.4.2.9.2,1.4s0,.9-.1,1.2c0,.4-.3.7-.7.9-.4.3-1,.5-1.8.7-.8.2-1.9.4-3.3.5l-10.4,1.1v-1.7ZM265.2,49.4c-.8-.2-1.4-.5-1.8-.9-.4-.4-.6-1-.7-1.8,0-.7-.1-1.7-.1-2.8,1.1,0,2.7-.1,4.9-.3,2.2-.1,4.8-.3,8-.5,2-.1,4-.5,5.8-1.1,1.8-.6,3.3-1.5,4.6-2.6,1.3-1.1,2.3-2.5,3.1-4,.7-1.6,1.1-3.4,1.1-5.5s-.4-4.2-1.1-5.9c-.7-1.7-1.8-3.1-3.1-4.1-1.3-1.1-2.9-1.9-4.7-2.5-1.8-.6-3.7-.8-5.9-.8h-9.2c-5.4,0-9.2,1.3-11.4,4-2.2,2.7-3.3,6.6-3.3,11.8v11.5c0,5.1,1.1,9,3.4,11.7,2.2,2.6,6,4,11.2,4h0s24.1,0,24.1,0v-10h-22.3c-1.1,0-1.9-.1-2.6-.2"
            />
            <path
              className="st6"
              d="M246,26.3v-9.3h-10.1V4.6h-11v12.4h-9.2v9.3h9.2v17.5c0,5.1,1.1,9,3.3,11.7,2.2,2.7,6,4.1,11.4,4.1s.1,0,.2,0h0s6.1,0,6.1,0v-10h-4.4c-1.3,0-2.4,0-3.1-.3-.8-.2-1.4-.5-1.8-1-.4-.5-.6-1.1-.7-1.9,0-.8-.1-1.8-.1-3v-17.2h10.1Z"
            />
            <polygon className="st6" points="96.5 77.5 90.2 77.5 90.2 80.5 95.8 80.5 95.8 82.3 90.2 82.3 90.2 86.8 88.2 86.8 88.2 75.7 96.5 75.7 96.5 77.5" />
            <path
              className="st6"
              d="M115,77.9l-1.9,4.5h3.8l-1.9-4.5ZM120.9,86.8h-2.1l-1.1-2.7h-5.3l-1.1,2.7h-2l4.9-11.2h1.8l4.9,11.2Z"
            />
            <path
              className="st6"
              d="M140.1,87c-3.3,0-5.7-2.5-5.7-5.8s2.4-5.8,5.8-5.8,3.3.7,4.4,1.7l-1.3,1.5c-.9-.8-1.9-1.4-3.1-1.4-2.1,0-3.7,1.8-3.7,4s1.5,4,3.7,4,2.3-.6,3.2-1.5l1.3,1.3c-1.2,1.2-2.4,2-4.5,2"
            />
            <rect className="st6" x="159.6" y="75.7" width="2" height="11.2" />
            <polygon className="st6" points="177.3 75.7 179.2 75.7 179.2 85.1 185.1 85.1 185.1 86.8 177.3 86.8 177.3 75.7" />
            <rect className="st6" x="200" y="75.7" width="2" height="11.2" />
            <polygon className="st6" points="222.5 86.8 220.5 86.8 220.5 77.5 217 77.5 217 75.7 226 75.7 226 77.5 222.5 77.5 222.5 86.8" />
            <rect className="st6" x="241" y="75.7" width="2" height="11.2" />
            <polygon className="st6" points="267 77.4 260.7 77.4 260.7 80.3 266.3 80.3 266.3 82.1 260.7 82.1 260.7 85.1 267.1 85.1 267.1 86.8 258.7 86.8 258.7 75.7 267 75.7 267 77.4" />
            <path
              className="st6"
              d="M286.5,80.4c2.4.6,3.6,1.4,3.6,3.3s-1.6,3.4-4,3.4-3.3-.6-4.7-1.8l1.2-1.4c1.1.9,2.1,1.5,3.5,1.5s2-.6,2-1.4-.4-1.2-2.5-1.7c-2.4-.6-3.7-1.3-3.7-3.3s1.6-3.3,3.8-3.3,2.9.5,4.1,1.4l-1.1,1.5c-1-.7-2-1.1-3-1.1s-1.8.6-1.8,1.3.5,1.3,2.6,1.8"
            />
            <path
              className="st6"
              d="M300,19.7c0,.5-.1,1-.4,1.5-.3.5-.6.8-1.1,1.1-.5.3-1,.4-1.5.4s-1-.1-1.5-.4c-.5-.3-.8-.6-1.1-1.1-.3-.5-.4-1-.4-1.5s.1-1,.4-1.5c.3-.5.6-.8,1.1-1.1.5-.3,1-.4,1.5-.4s1.1.1,1.5.4c.5.3.8.6,1.1,1.1.3.5.4,1,.4,1.5M299.4,19.7c0-.7-.2-1.2-.7-1.7-.5-.5-1-.7-1.7-.7s-1.2.2-1.7.7c-.5.5-.7,1-.7,1.7s.1.8.3,1.2c.2.4.5.7.9.9.4.2.8.3,1.2.3s.8-.1,1.2-.3c.4-.2.7-.5.9-.9.2-.4.3-.8.3-1.2M295.7,18h1.5c.3,0,.5,0,.7.1.1,0,.3.2.4.3,0,.1.1.3.1.5s0,.3,0,.4c0,.1-.2.2-.3.3.1,0,.2.1.2.2,0,0,0,.2,0,.5,0,.4,0,.7,0,.7,0,0,0,.1.1.2h-.8c0,0,0-.2,0-.2,0,0,0-.2,0-.3,0-.3,0-.5,0-.5s0-.1-.1-.2c0,0-.2,0-.4,0h-.6v1.3h-.7v-3.3ZM296.4,18.6v.8h.6c.2,0,.4,0,.5,0,0,0,.1-.2.1-.3s0-.2-.1-.3c0,0-.2,0-.5,0h-.6Z"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          className="st0"
          d="M16.3,117.3v19.6h-3.9v-8.3H3.9v8.3H0v-19.6h3.9v8.1h8.4v-8.1h3.9Z"
        />
        <path className="st0" d="M24.1,117.3v19.6h-3.9v-19.6h3.9Z" />
        <path
          className="st0"
          d="M38.1,136.9l-4.3-7.6h-1.9v7.6h-3.9v-19.6h7.4c1.5,0,2.8.3,3.9.8,1.1.5,1.9,1.3,2.4,2.2.5.9.8,1.9.8,3s-.4,2.5-1.1,3.5-1.9,1.8-3.3,2.1l4.7,8h-4.6ZM31.9,126.3h3.3c1.1,0,1.9-.3,2.4-.8.5-.5.8-1.2.8-2.1s-.3-1.6-.8-2.1c-.5-.5-1.3-.7-2.4-.7h-3.3v5.8Z"
        />
        <path
          className="st0"
          d="M49.9,120.5v4.9h6.6v3.1h-6.6v5.2h7.4v3.2h-11.4v-19.6h11.4v3.2h-7.4Z"
        />
        <path className="st4" d="M77,136.4h-1.5v-18.7h1.5v18.7Z" />
        <path
          className="st0"
          d="M98.7,136.3c-1.1-.5-2-1.1-2.6-2-.6-.9-1-1.9-1-3.1h4.2c0,.8.3,1.4.9,1.9.5.5,1.2.7,2.1.7s1.6-.2,2.2-.7.8-1,.8-1.7-.2-1.1-.5-1.4-.8-.7-1.3-.9c-.5-.2-1.3-.5-2.2-.7-1.3-.4-2.3-.7-3.1-1.1-.8-.4-1.5-.9-2.1-1.7-.6-.7-.9-1.7-.9-3s.3-2.2.9-3c.6-.9,1.4-1.5,2.4-2,1-.5,2.2-.7,3.6-.7,2,0,3.7.5,4.9,1.5,1.3,1,2,2.4,2.1,4.1h-4.3c0-.7-.3-1.2-.9-1.7-.5-.4-1.2-.7-2.1-.7s-1.4.2-1.8.6c-.5.4-.7,1-.7,1.7s.2,1,.5,1.3c.3.3.8.6,1.3.8.5.2,1.2.5,2.2.7,1.3.4,2.3.7,3.1,1.1.8.4,1.5.9,2.1,1.7.6.7.9,1.7.9,3s-.3,2-.8,2.9c-.5.9-1.3,1.6-2.4,2.1-1,.5-2.3.8-3.7.8s-2.6-.2-3.7-.7Z"
        />
        <path
          className="st0"
          d="M124.8,133.1h-7.8l-1.3,3.7h-4.1l7.1-19.6h4.6l7.1,19.6h-4.2l-1.3-3.7ZM123.7,129.9l-2.8-8.2-2.8,8.2h5.7Z"
        />
        <path
          className="st0"
          d="M136.8,133.7h6.5v3.1h-10.4v-19.6h3.9v16.5Z"
        />
        <path
          className="st0"
          d="M149.7,120.4v4.9h6.6v3.1h-6.6v5.2h7.4v3.2h-11.4v-19.6h11.4v3.2h-7.4Z"
        />
        <path className="st4" d="M176.6,136.3h-1.5v-18.7h1.5v18.7Z" />
        <path className="st1" d="M198.7,117.2v19.6h-3.9v-19.6h3.9Z" />
        <path
          className="st1"
          d="M219.4,136.9h-3.9l-8.9-13.5v13.5h-3.9v-19.6h3.9l8.9,13.5v-13.5h3.9v19.6Z"
        />
        <path
          className="st1"
          d="M226.3,136.3c-1.1-.5-2-1.1-2.6-2-.6-.9-1-1.9-1-3.1h4.2c0,.8.3,1.4.9,1.9.5.5,1.2.7,2.1.7s1.6-.2,2.2-.7.8-1,.8-1.7-.2-1.1-.5-1.4-.8-.7-1.3-.9c-.5-.2-1.3-.5-2.2-.7-1.3-.4-2.3-.7-3.1-1.1-.8-.4-1.5-.9-2.1-1.7-.6-.7-.9-1.7-.9-3s.3-2.2.9-3c.6-.9,1.4-1.5,2.4-2,1-.5,2.2-.7,3.6-.7,2,0,3.7.5,4.9,1.5,1.3,1,2,2.4,2.1,4.1h-4.3c0-.7-.3-1.2-.9-1.7-.5-.4-1.2-.7-2.1-.7s-1.4.2-1.8.6c-.5.4-.7,1-.7,1.7s.2,1,.5,1.3c.3.3.8.6,1.3.8.5.2,1.2.5,2.2.7,1.3.4,2.3.7,3.1,1.1.8.4,1.5.9,2.1,1.7.6.7.9,1.7.9,3s-.3,2-.8,2.9c-.5.9-1.3,1.6-2.4,2.1-1,.5-2.3.8-3.7.8s-2.6-.2-3.7-.7Z"
        />
        <path
          className="st1"
          d="M253.7,117.2v3.2h-5.2v16.4h-3.9v-16.4h-5.2v-3.2h14.4Z"
        />
        <path
          className="st1"
          d="M268.6,133.1h-7.8l-1.3,3.7h-4.1l7.1-19.6h4.6l7.1,19.6h-4.2l-1.3-3.7ZM267.5,130l-2.8-8.2-2.8,8.2h5.7Z"
        />
        <path
          className="st1"
          d="M280.6,133.7h6.5v3.1h-10.4v-19.6h3.9v16.5Z"
        />
        <path
          className="st1"
          d="M293.5,133.7h6.5v3.1h-10.4v-19.6h3.9v16.5Z"
        />
      </g>
    </svg>
  );
};

export default LogoIcon;
